import styled from "styled-components";

import { breakpoints } from '../../../styles/variables';

export const SSection = styled.section`
    display: flex;
    flex-direction: column;
    align-items: center;
    width: 100%;
    padding: 3rem 2rem;
    overflow: hidden;
    position: relative;

    background-color: ${({ background }) => ( background || '#fff')};

    @media (min-width: ${ breakpoints.medium }) {
        padding: 7rem 3rem;
    }
`;

export const SSectionContent = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    width: 100%;
    max-width: 114rem;
    z-index: 5;
`;
